export const GET_USER_RES_TICKET = 'GET_USER_RES_TICKET';


export const USER_RES_TICKET_ACTION = 'USER_RES_TICKET_ACTION';

export const OPEN_SOLVE_DIALOG = 'OPEN_SOLVE_DIALOG';

export const CLOSE_SOLVE_DIALOG = 'CLOSE_SOLVE_DIALOG';